import { DefaultNullStringValue } from "./appConstants";

export const logError = (error: unknown) => {
    console.error(error);
};

export const toNullableLocaleDateTimeString = (timestamp: Date | null) => {
    if (timestamp === null) {
        return DefaultNullStringValue;
    }

    const d = new Date(timestamp);
    
    return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
}

export const formatNullableString = (value: string | null | '') => {
    if (value === null || value.trim() === "") {
        return DefaultNullStringValue;
    }

    return value;
}